import { z } from 'my-zod'
import { invitedGuestFragment } from './invited-guest-fragment'

export const superRefineNonMinorEmailCheck = (values: z.infer<typeof invitedGuestFragment>, ctx: z.RefinementCtx) => {
  if (values.guestType !== 'MinorFamilyMember' && !values.email) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'email is required for non-minor family members'
    })
  }
}

export const invitedGuest = invitedGuestFragment
  .augment({
    phone: z.string().nullish(),
    transactionalSMSOptIn: z.boolean(),
    isMinor: z.boolean().optional(),
    isParticipantMinor: z.boolean().optional()
  })
  .superRefine(superRefineNonMinorEmailCheck)

export type invitedGuest = z.infer<typeof invitedGuest>
